/**
 * 24 h volume on market-list rows and tiles (#874): a "24h vol" stat on wide screens, a compact "Vol $X" on phones.
 * Nothing renders until the volume is known.
 */
import type { DayVolume } from './volume';
import { formatVolumeUsd } from './format';
import { useT } from '../i18n/useT';

/** Wide screens (sm and up): caption + amount, next to the price. */
export function VolumeStat({ volume, testId }: { volume: DayVolume | undefined; testId: string }) {
  const t = useT();
  if (!volume) return null;
  return (
    <div className="hidden shrink-0 text-end sm:block" data-testid={testId}>
      <div className="num text-sm font-medium">{formatVolumeUsd(volume.usd)}</div>
      <div className="text-[11px] uppercase tracking-wide text-muted">{t('volume.col_24h')}</div>
    </div>
  );
}

/** Phones (below sm): "Vol $1.2M". */
export function VolumeCompact({ volume, testId }: { volume: DayVolume | undefined; testId: string }) {
  const t = useT();
  if (!volume) return null;
  const amount = formatVolumeUsd(volume.usd);
  return (
    <span
      className="num shrink-0 text-[11px] text-muted sm:hidden"
      data-testid={testId}
      title={t('volume.compact_aria', { amount })}
    >
      {t('volume.compact', { amount })}
    </span>
  );
}
